<template>
  <ViewContainer :px="6">
    <v-layout column fill-height justify-space-between>
      <v-flex>
        <section class="page-title-box mb-10">
          <p>지원 준비중인 플랫폼이에요.</p>
          <h1>
            이용이 가능할 때<br />
            빠르게 연락 드릴게요!
          </h1>
        </section>

        <section class="text-center" :class="{ 'pt-7': $vuetify.breakpoint.height >= 700 }">
          <img src="@/assets/images/signup/call.svg" />
        </section>
      </v-flex>

      <section class="page-footer-column">
        <BasicButton block :to="{ name: 'main' }"> 확인 </BasicButton>
      </section>
    </v-layout>
  </ViewContainer>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  async created() {
    await Promise.all([this.getMalls(), this.getMe()])
  },
  methods: {
    ...mapActions('mall', ['getMalls']),
    ...mapActions('auth', ['getMe']),
  },
}
</script>
